import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { DomainIndexRow } from "routes/system-admin/sso-overview/domain-index-row"
import { NoEstateResults } from "routes/system-admin/sso-overview/no-estate-results"

/**
 * The support-facing answer to "which organisation already has this domain?".
 *
 * A flat list is the right shape because the uniqueness rule is global — checkDomainValidity in
 * the SSO config module rejects a domain that appears on ANY other client's configuration, with
 * no client filter — so a domain appears here at most once by construction.
 */
export function DomainIndexTable({ domains = [] }) {
    return (
        <TableContainer>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {`Email domain index (${domains.length})`}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
                An email domain can belong to only one identity provider across the whole platform. This is where a
                client is told their domain is already configured.
            </Typography>
            <Table size="small" data-cy="sso-estate-domain-table">
                <TableHead>
                    <TableRow>
                        <TableCell>Email domain</TableCell>
                        <TableCell>Owned by</TableCell>
                        <TableCell>Provider</TableCell>
                        <TableCell>SSO</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Repeat
                        list={domains}
                        keyFn={keyForDomain}
                        item={<DomainIndexRow />}
                        fallback={<NoEstateResults columns={4} message="No email domains are configured." />}
                    />
                </TableBody>
            </Table>
        </TableContainer>
    )

    function keyForDomain(entry) {
        return entry.domain
    }
}
